/*!
 * e3-modal JavaScript Library v0.0.21
 *
 * Released under the MIT license
 *
 * Date: 2015-10-08T16:49Z
 */

(function(global, factory) {

  if (typeof define === 'function' && define.amd) {
    define('e3-form',
      ['jquery', 'underscore', 'vertebrae', 'bluebird', 'handlebars', 'e3-table', 'moment', 'bootstrap-datepicker', 'redactor'], factory);
  } else {
    factory((global.jQuery || global.$), global._, {}, global.Promise, global.Handlebars, global.E3Table, global.moment);
  }

}(this, function($, _, Vertebrae, Promise, Handlebars, E3Table, moment) {

  var AttachmentModel = Vertebrae.Model.extend({

    serverProperties: [
      'fileType',
      'id',
      'text',
      'url'
    ]

  });


  var FormModel = Vertebrae.Object.extend({

    properties: [
      'answerProcessor',
      'answers',
      'attachmentModel',
      'attachments',
      'children',
      'formEntityMap',
      'generatedIds',
      'maxDepth',
      'progressiveDisclosure',
      'template',
      'types'
    ],

    initialize: function(properties) {
      this.setGeneratedIds([]);

      // process in the available types
      var types = _.extend({}, this.constructor.types, properties.types);
      
      properties.types = {};

      _.each(types, function(typeDef, name) {
        properties.types[name.toLowerCase()] = typeDef;
      });

      // apply properties that were pased in
      this.applyProperties(_.extend({}, this.defaults(), properties));

      // initialize variables
      this.setFormEntityMap({});

      // start initializing the form elemnts
      this.trigger('init:start');

      // initialize form entities
      this.initializeEntityChildren(this);
      this.setAttachments(_.map(this.getAttachments(), this.initializeFormAttachment, this));

      // we are done setup up all elements
      this.trigger('init:done');

    },

    defaults: function() {
      return {
        attachmentModel: AttachmentModel,
        // processes answers through the given function
        answerProcessor: null,
        maxDepth: 7
      };
    },

    getSections: function() {
      return this.getChildren();
    },

    has: function(prop) {
      return !!this.getter(prop);
    },

    start: function() {

      return  Promise
          .bind(this)
          .tap(function() {
            if (this.has('progressiveDisclosure')) {
              return this.startProgressiveDisclosureListeners();
            }
          })
          .tap(function() {
            if (this.has('answers')) {
              return Promise.all(_.map(this.getAnswers(), this.setupAnswer, this));
            }
          })

    },

    serializeAnswers: function(entity) {
      var data = [],
          add  = null;

      add = function(answer) {
        if (answer) {
          data.push(answer);
        }
      };

      if (!_.isObject(entity)) {
        entity = this.getFormEntityById(entity);
      }

      if (entity) {
        entity.recurse(function(e) {
          add(this.serializeEntity(e));
        }, this);

        _.each(this.getAttachments(), function(e) {
          add(this.serializeEntity(e));
        }, this);
      } else {
        this.recurse(function(e) {
          add(this.serializeEntity(e));
        }, this);
      }

      return data;
    },

    serializeEntity: function(entity) {
      var value = entity.serializeAnswer(entity.getValue());

      if (value === undefined) {
        return;
      }

      return {
        id: entity.getId(),
        value: value
      };
    },

    startProgressiveDisclosureListeners: function() {
      this.recurse(function(entity) {
        entity.startProgressiveDisclosureListeners();
      });
    },

    recurse: function(fn, context) {

      function _recurse(list) {
        var len = list.length;
        var i;

        for (i=0; i < len; i++) {
          if (fn.call(context || this, list[i]) === true) {
            return list[i];
          } 
          var rtn = list[i].recurse(fn, context);
          if (rtn) {
            return rtn;
          }
        }
      }

      var found = _recurse(this.getChildren());

      if (found) {
        return found;
      }

      found = _recurse(this.getAttachments());

      return found;
    },

    initializeEntityChildren: function(entity) {
      // use _.bind to curry initializeFormEntity so that entity is passed as the parent argument
      entity.setChildren(_.map(entity.getChildren(), _.bind(this.initializeFormEntity, this, entity)));
    },

    setupAnswer: function(answer) {
      var entity = this.getFormEntityById(answer.id),
          value  = null;

      if (entity) {
        value = entity.deserializeAnswer(answer.value, answer);

        return Promise
            .bind(this)
            .then(function() {
              var fn = this.getAnswerProcessor();

              if (_.isFunction(fn)) {
                return fn.call(this, entity, value);
              }
              return value;
            })
            .tap(function(processedValue) {
              entity.setValue(entity.setupValue(processedValue));
            });
      }
    },

    getFormEntityModelByType: function(type) {
      // return the form entity type constructor by the type
      var typeDef = this.getTypes()[String(type)] || FormModel.types.base;

      if (!typeDef.model) {
        throw new Error('You Must declare a model on your type definition.');
      }

      return typeDef.model;
    },

    getFormEntityNameByType: function(type) {
      var typeDef = this.getTypes()[String(type).toLowerCase()] || FormModel.types.base;
      

      return typeDef.name || FormModel.types.group.name;
    },

    migrateEntityProperties: function(properties) {
      var type = String(properties.type).toLowerCase();

      if (type == 'question' || type == 'subsection') {
        properties.type = 'group';
      }

      return properties;
    },

    initializeFormEntity: function(parent, child, index) {
      child           = this.migrateEntityProperties(child);

      var type        = child.type,
          Constructor = null,
          entity      = null;


      // add the form reference
      child.form = this;
      child.index = index;

      // if the parent is the form itself
      if (parent === this) {
        child.depth = 0;
      } else if (parent) {
        child.depth = parent.getDepth() + 1;
      }

      child.parent = parent;

      if (!child.name) {
        child.name = this.generateFormEntityName(type);
      }

      Constructor = this.getFormEntityModelByType(type);
      entity = new Constructor(child);

      this.listenTo(entity, "change:value", function() {
        this.trigger("change:entity:value", entity);
      });

      this.listenTo(entity, "destroy", function() {
        this.stopListening(entity);
      });

      this.getFormEntityMap()[entity.getId()] = entity;

      this.initializeEntityChildren(entity);

      return entity;
    },


    initializeFormAttachment: function(properties, index, noParent) {
      properties.type = 'attachmentpoint';
      // set the model to be used for attachments
      properties.model = this.getAttachmentModel();
      return this.initializeFormEntity(noParent === true ? null : this, properties, index);
    },

    createFormAttachment: function() {
      return this.initializeFormAttachment({ id: this.generateId() }, null, true);
    },

    createFormEntity: function(type) {
      return this.initializeFormEntity(null, { id: this.generateId(), type: type }, null);
    },

    detachFormEntity: function(entity) {
      var parent = entity.getParent();

      entity.setParent(null);

      if (!parent) {
        // if we do not have a parent then we are already detached;
        return entity;
      }

      var children = entity.isAttachmentPoint() ? this.getAttachments() : parent.getChildren();

      children = children.slice();

      var index = _.indexOf(children, entity);

      if (index >= 0) {

        children.splice(index, 1);

        for (var i = index, len = children.length; i < len; i++) {
          children[i].setIndex(i);
        }

        parent.setChildren(children);
      }

      return entity;
    },

    attach: function(entity, index) {
      this.attachFormEntity(entity, this, index);
      return this;
    },

    attachNewAttachmentPoint: function(index) {
      var entity = this.createFormAttachment();
      this.attachFormEntity(entity, this, index);
      return entity;
    },

    attachNewSection: function(index) {
      var entity = this.createFormEntity('group');
      this.attachFormEntity(entity, this, index);
      return entity;
    },

    attachFormEntity:  function(entity, parent, index) {
      if (this.canAttachFormEntity(entity, parent, index)) {
        entity.setParent(parent);

        entity.detach();

        var children = entity.isAttachmentPoint() ? this.getAttachments() : parent.getChildren();
        children = children.slice();

        index = index != null ? index : children.length;

        children.splice(index, 0, entity);
        entity.setIndex(index);

        if (parent === this) {
          entity.setDepth(0);
        } else {
          entity.setDepth(parent.getDepth() + 1);
        }

        entity.recurse(function(e) {
          e.setDepth(e.getParent().getDepth() + 1);
        })

        for (var i = index+1, len = children.length; i < len; i++) {
          children[i].setIndex(i);
        }

        entity.isAttachmentPoint() ? this.setAttachments(children) : parent.setChildren(children);
        
      } else {
        // cant attach form entity
        throw new Error("Cant attach form entity", entity, "to parent because it failed verification.");
      }
    },

    canAttachFormEntity: function(entity, parent, index) {
      if (!this.canAttachFormEntityType(entity.getType(), parent, index)) {
        return false;
      } else if (entity.containsChild(parent)) {
        return false
      } else if (parent !== this && parent.getDepth() >= this.getMaxDepth()) {
        return false;
      } else if (_.isFunction(this.attachProcessor) && !this.attachProcessor(entity, parent, index)) {
        return false;
      }
      return true;
    },

    canAttachFormEntityType: function(type, parent, index) {
      var compoundType = parent !== this && parent.getCompoundType();

      if (compoundType && compoundType != type) {
        return false;
      } else if (_.isFunction(this.attachTypeProcessor) && !this.attachTypeProcessor(type, parent, index)) {
        return false;
      }
      return true;
    },

    generateId: function() {
      this._clientIdCounter = this._clientIdCounter || 0;
      var newId = "c" + this._clientIdCounter++;

      this.getGeneratedIds().push(newId);

      return newId;
    },

    updateGeneratedIds: function(realIds) {
      var generatedIds = this.getGeneratedIds(),
          len          = Math.min(realIds.length, generatedIds.length),
          map          = this.getFormEntityMap(),
          genId,
          fe;

      for (var i = 0; i < len; i++) {
        genId = generatedIds.pop();
        fe = this.getFormEntityById(genId);
        if (fe) {
          fe.setId(realIds.pop());
          delete map[genId];
          map[fe.getId()] = fe;
        }
      }
    },

    generateFormEntityName: function(type) {
      // This could use some optimization...
      var prefCache   = this._namePrefixCache = this._namePrefixCache || {},
          // TODO we need to map type to prefix
          prefix      = this.getFormEntityNameByType(type),
          numberToTry = 1;

      if (prefCache[prefix] != null) {
        // If there is no suggestion, see if we've used this prefix before and 
        // use the next number
        numberToTry = prefCache[prefix]+1
      } else {
        // No suggestion, we've never used this prefix, lets use 1
        numberToTry = 1;
      }
      
      // While the names we are generating are 
      while (this.getFormEntityByName(prefix + String(numberToTry)) != null) {
        numberToTry++;
      }

      prefCache[prefix] = numberToTry;

      return prefix + String(numberToTry);
    },

    dependencyLink: function(type, dependent, dependency) {
      if (this.canLinkDependency(type, dependent, dependency)) {
        // the dependent depends on its dependency
        dependent.addDependency(type, dependency);
        dependency.addDependent(type, dependent);
      } else {
        throw new Error("Can't link", dependency, "to", dependent, "because it failed verification.");
      }
    },

    canLinkDependency: function(type, dependent, dependency) {
      if (dependent === dependency) {
        return false;
      } else if (dependent.containsChild(dependency)) {
        return false;
      } else if (dependency.hasDependent(type, dependent)) {
        return false;
      } else if (_.isFunction(this.linkProcessor) && !this.linkProcessor(type, dependent, dependency)) {
        return false;
      }
      
      return true;
    },

    dependencyUnlink: function(type, dependent, dependency) {
      // the dependent depends on its dependency
      dependent.removeDependency(dependency);
      dependency.removeDependent(dependent);
    },


    resolveDependencies: function(entity) {
      var dependencies = entity.getDependencies();

      entity.setDependencies([]);

      _.each(dependencies, function(dep) {
        var dependency = this.getFormEntityById(dep.targetId);

        if (dependency) {
          this.dependencyLink(dep.type, entity, dependency);
        }

      }, this);
    },

    getFormEntityById: function(id) {
      return this.getFormEntityMap()[id];
    },

    getFormEntityByName: function(name) {
      return this.recurse(function(entity) {
        return entity.name == name;
      });
    },

    toJSON: function() {
      var children    = this.getChildren(),
          attachments = this.getAttachments();

      return {
        children    : children,
        attachments : attachments
      }
    }

  });


  var TransportFormEntity = Vertebrae.Object.extend({

    properties: [
      'assignmentType',
      'children',
      'compoundType',
      'dependencies',
      'description',
      'hasMultiple',
      'helpText',
      'id',
      'label',
      'name',
      'required',
      'samples',
      'text',
      'type'
    ],

    initialize: function(properties) {
      properties = _.extend({}, this.defaults(), properties);

      // map dataId to id and delete dataId
      if (properties.dataId != null) {
        properties.id = properties.dataId;
        delete properties.dataId;
      }

      this.applyProperties(properties);
    },

    defaults: function() {
      return {
        children: [],
        required: false
      };
    },

    serializeDependency: function(dep) {
      return {
        type: dep.type,
        targetId: dep.target.id
      };
    },

    deserializeAnswer: function(value) {
      return value;
    },

    serializeAnswer: function(value) {
      return value;
    },

    toJSON: function() {
      var json = _.pick(this, TransportFormEntity.prototype.properties);

      // map over id to dataId
      json.dataId = json.id;
      delete json.id;

      // map up the dependencies to their targetId
      json.dependencies = _.map(this.getDependencies(), this.serializeDependency, this);

      return json;
    }

  });


  var BaseFormEntityModel = TransportFormEntity.extend({

    properties: [
      'completion',
      'dependents',
      'depth',
      'disabled',
      'discloseDependentsFlag',
      'displayed',
      'form',
      'index',
      'parent',
      'value'
    ],

    initialize: function() {
      this._super.apply(this, arguments);
      this.setDependents([]);
      this.setDependencies(this.getDependencies() || []);
      // this lets us know when all entities of this form have been initialized
      this.listenToOnce(this.getForm(), 'init:done', this.initDidFinish);
    },

    defaults: function() {
      return _.extend(this._super(), {
        displayed: true
      });
    },

    initDidFinish: function() {
      // setup dependencies
      this.getForm().resolveDependencies(this);
    },

    setupValue: function(value) {
      return value;
    },

    recurse: function(fn, context) {
      var list = this.getChildren(),
          len = list.length,
          i;

      for (i=0; i < len; i++) {
        if (fn.call(context || this, list[i]) === true) {
          return list[i];
        } 
        var rtn = list[i].recurse(fn, context);
        if (rtn) {
          return rtn;
        }
      }
    },

    setName: function(value, options) {
      if (_.isString(value)) {
        // Only alpha numeric here...
        value = value.replace(/\W/g, '');

        if (value.length) {
          this._super(value, options);
        }
      } 
    },

    containsChild: function(child) {
      return this.recurse(function(c) {
        return c === child;
      });
    },

    getSection: function() {
      return this.isSection() ? this : (this.getParent() ? this.getParent().getSection() : null);
    },

    getSiblings: function() {
      var siblings = [],
          parent   = this.getParent(),
          children;

      if (!parent) {
        return siblings;
      }

      children = parent.getChildren();

      for (var i = 0, len = children.length; i < len; ++i) {
        if (children[i] !== this) {
          siblings.push(children[i]);
        }
      }

      return siblings;
    },

    startProgressiveDisclosureListeners: function() {
      // If my displayed changes, this may affect wether or not
      // my children are displayed (isDisplayed being a combination of
      // the displayed property and the parents display state.)  We need
      // to tell them to recalculate their 'isDisplayed' value
      this.listenTo(this, 'change:displayed', function() {
        this.recurse(function(entity) {
          entity.refreshDiscloseDependentsFlag();
        });
      });
      // this is to the dependencies
      this.listenTo(this, 'change:displayed', this.refreshDiscloseDependentsFlag);
      this.listenTo(this, 'change:value', this.refreshDiscloseDependentsFlag);

      // this is to re-calculate completion
      this.listenTo(this, 'change:value', this.refreshCompletion);
      this.listenTo(this, 'change:displayed', this.refreshCompletion);
      this.listenTo(this, 'change:required', this.refreshCompletion);

      _.each(this.getDependencies(), function(dep) {
        // when a dependency's disclosure has changed....we need to refresh
        // the property that depends on it.
        this.listenTo(dep.target, 'change:discloseDependentsFlag', function() {
          this.refreshProperty(dep.type);
        });
        // call this once to setup the dependency linking
        this.refreshProperty(dep.type);
      }, this);

      this.refreshCompletion();
    },

    refreshCompletion: function() {
      var section = this.getSection(),
          that    = this;

      if (!section) {
        return;
      }

      if (this.isSection()) {

        if (!this._refreshCompletion) {

          // Only Refresh this section once per tick
          this._refreshCompletion = setTimeout(function() {
              that.setCompletion(that.evaluateCompletion());
              that._refreshCompletion = null;
            }, 0);
        }

      } else {
        this.getSection().refreshCompletion();
      }
    },

    refreshDiscloseDependentsFlag: function() {
      if (this.isAnswered() && this.isDisplayed()) {
        this.setDiscloseDependentsFlag(true);
      } else {
        this.setDiscloseDependentsFlag(false);
      }
    },

    refreshProperty: function(type) {
      switch (type) {
        case 'attach':
          var displayed =_.some(this.getDependenciesByType(type), function(entity) {
            // this entity will always but the attach button in the form
            return entity.isDisplayed();
          });
          this.setDisplayed(displayed);
          break;
        case 'displayed':
        case 'required':
          if (this.shouldBeDisclosedByType(type)) {
            this.setter(type, true);
          } else {
            this.setter(type, false);
          }
          break;
      }
    },

    reloadValue: function() {
      this.setValue(this.getValue(), {trigger: true});
    },

    deserializeAnswer: function(value) {
      return value;
    },

    serializeAnswer: function(value) {
      return value;
    },

    isAnswered: function() {
      return !!this.getValue();
    },

    isDisplayed: function() {
      // getDisplayed returns my current displayed and my parents displayed
      // if I do not have a parent then i just go off of myself
      return this.getDisplayed() && (this.isSection() || !this.getParent() || this.getParent().isDisplayed());
    },

    isGroup: function() {
      // yes....it really could be any of these.....
      return this.getType() == "question" || this.getType() == "group" || this.getType() == "subsection";
    },

    isSection: function() {
      return this.getDepth() == 0 && !this.isAttachmentPoint();
    },

    isAttachmentPoint: function() {
      return this.getType() === 'attachmentpoint';
    },

    isAttachmentButton: function() {
      return this.getType() == 'attachment';
    },

    isRequired: function() {
      return this.getRequired();
    },

    equalsAnswer: function(entity) {
      if (this.getType() != entity.getType()) {
        return false;
      } else {
        return this.getValue() == entity.getValue();
      }
    },

    addDependent: function(type, dependent) {
      this.getDependents().push({
        type: type,
        target: dependent
      });
    },

    removeDependent: function(type, dependent) {
      var dependents = this.getDependents().slice();
      for (var i = 0, len = dependents.length; i < len; i++) {
        if (dependents[i].type === type && dependents[i].target === dependent) {
          dependents.splice(i, 1);
          this.setDependents(dependents);
          break;
        }
      }
    },

    addDependency: function(type, dependency) {
      this.getDependencies().push({
        type: type,
        target: dependency
      });
    },

    removeDependency: function(type, dependency) {
      var dependencies = this.getDependencies().slice();
      for (var i = 0, len = dependencies.length; i < len; i++) {
        if (dependencies[i].type === type && dependencies[i].target === dependency) {
          dependencies.splice(i, 1);
          this.setDependencies(dependencies);
          break;
        }
      }
    },

    hasDependent: function(type, formEntity) {
      var dependents = this.getDependentsByType(type);

      if (formEntity) {

        return _.indexOf(dependents, formEntity) > -1;
      } else {

        return dependents.length > 0;
      }
    },

    hasDependency: function(type, formEntity) {
      var dependencies = this.getDependenciesByType(type);

      if (formEntity) {

        return _.indexOf(dependencies, formEntity) > -1;
      } else {

        return dependencies.length > 0;
      }
    },

    evaluateCompletion: function() {
      var required          = [],
          valid             = [],
          invalid           = [],
          percent           = 0,
          calculateValidity = null;

      calculateValidity = function(entity) {
        // Add Only if Required and Visible
        if (entity.isRequired() && entity.isDisplayed()) {
          required.push(entity);
          // Add if answered
          if (entity.isAnswered()) {
            valid.push(entity);
          } else {
            invalid.push(entity);
          }
        }
      };

      calculateValidity(this);
      this.recurse(calculateValidity);

      if (required.length == 0) {
        percent = 100;
      } else {
        percent = valid.length*100/required.length;
      }

      return { valid: valid, required: required, invalid: invalid, percent: percent };
    },

    shouldBeDisclosedByType: function(type) {
      return _.some(this.getDependenciesByType(type), function(entity) {
        return entity.getDiscloseDependentsFlag();
      });
    },

    getDependentsByType: function(type) {
      var dependents = this.getDependents(),
          targets    = [],
          len        = dependents ? dependents.length : 0,
          i          = 0;

      for (i = 0; i < len; ++i) {
        if (dependents[i].type == type) {
          targets.push(dependents[i].target);
        }
      }

      return targets;
    },

    getDependenciesByType: function(type) {
      var dependencies = this.getDependencies(),
          targets    = [],
          len        = dependencies ? dependencies.length : 0,
          i          = 0;

      for (i = 0; i < len; ++i) {
        if (dependencies[i].type == type) {
          targets.push(dependencies[i].target);
        }
      }

      return targets;
    },

    attachTo: function(parent, index) {
      this.getForm().attachFormEntity(this, parent, index);
      return this;
    },

    attach: function(child, index) {
      this.getForm().attachFormEntity(child, this, index);
      return this;
    },

    detach: function() {
      this.getForm().detachFormEntity(this);
      return this;
    },

    destroy: function() {
      this.trigger('destroy');
      this.stopListening();

      var dependencies = this.getDependencies(),
          dependents   = this.getDependents(),
          children     = this.getChildren(),
          d;

      for (var i = 0, len = dependencies.length; i < len; i++) {
        d = dependencies[i];
        d.target.removeDependent(d.type, this);
      }

      for (var i = 0, len = dependents.length; i < len; i++) {
        d = dependents[i];
        d.target.removeDependency(d.type, this);
      }

      var f = this.getForm();
      if (f) {
        delete f.getFormEntityMap()[this.getId()];
      }

      for (var i = 0, len = children.length; i < len; ++i) {
        children[i].destroy();
      }

    }

  });


  var BooleanFormEntityModel = BaseFormEntityModel.extend({

    isAnswered: function() {
      return this.parseBoolean(this.getValue());
    },

    parseBoolean: function(value) {
      if (value === true || String(value).toLowerCase() === 'true') {
        return true;
      }
      return false;
    },

    deserializeAnswer: function(value) {
      return this.parseBoolean(value);
    },

    serializeAnswer: function(value) {
      return this.parseBoolean(value);
    }

  });


  var ExclusiveBooleanFormEntityModel = BooleanFormEntityModel.extend({

    setValue: function(value) {
      this._super.apply(this, arguments);
      
      if (value) {
        this.updateSiblingValues();
      }
    },

    reloadValue: function() {
      this._super.apply(this, arguments);
      this.updateSiblingValues();
    },

    updateSiblingValues: function() {
      var parent = this.getParent(),
          type   = this.getType(),
          value  = !!this.getValue(),
          siblings,
          sibling;

      // If true, we want to set all of our siblings to false
      if (parent && parent.getCompoundType() == type) {
        siblings = this.getSiblings();
        for (var i = 0, len = siblings.length, sibling; i < len; i++) {
          sibling = siblings[i];
          if (sibling.getType() == type) {
            if (value) {
              sibling.setValue(false);
            } else {
              sibling.trigger("change:value");
            }
          }
        }
      }
    }

  });


  var DateFormEntityModel = BaseFormEntityModel.extend({

    deserializeAnswer: function(value) {
      if (!value) {
        return null;

      // Date in milliseconds format
      } else if (_.isNumber(value)) {
        return new Date(value);
      }

      // Date string format
      return value;
    },

    serializeAnswer: function(value) {
     
      // Won't ever be called since retrieving value as a string
      // element.val()
      if (_.isDate(value)) {
        value = value.getTime();
        // make sure the time is a valid time
        if (_.isNaN(value)) {
          value = null;
        }
      }

      return value;
    }

  });


  var GroupFormEntityModel = BaseFormEntityModel.extend({

    startProgressiveDisclosureListeners: function() {

      this._super();

      _.each(this.getChildren(), function(child) {

        this.listenTo(child, 'change:discloseDependentsFlag', function() {

          var some = _.some(this.getChildren(), function(child) {
            return child.getDiscloseDependentsFlag();
          });
          if (some) {
            this.setValue(true);
          } else {
            this.setValue(false);
          }
        });

      }, this);
    },

    serializeAnswer: function() {
      // do not return anything because there are no values for a group
    },

    deserializeAnswer: function() {
      return false;
    }

  });


  var RecordFormEntityModel = BaseFormEntityModel.extend({

    initialize: function() {
      this._super.apply(this, arguments);
      this.setValue([]);
    },

    isAnswered: function() {
      return !_.isEmpty(this.getValue());
    },

    equalsAnswer: function(entity) {
      if (this.getType() != entity.getType()) {
        return false;
      } else {
        var myIds    = _.pluck(this.getValue(), 'id'),
            otherIds = _.pluck(entity.getValue(), 'id');

        if (myIds.length != otherIds.length) {
          return false;
        } else if (_.difference(myIds, otherIds).length > 0) {
          return false;
        } else if (_.difference(otherIds, myIds).length > 0) {
          return false;
        }
      }
      return true;
    },

    deserializeAnswer: function(value) {
      try {

        var value = JSON.parse(value);
        
        if (_.isArray(value)) {
          return value;
        }
        return [value];
      } catch (e) {

        return [];
      }
    },

    serializeAnswer: function(value) {
      if (_.isEmpty(value)) {

        return null;
      }
      return JSON.stringify(value);
    }

  });


  var AttachmentFormEntityModel = RecordFormEntityModel.extend({

    initialize: function() {
      this._super.apply(this, arguments);

      // If this is an attachment point, we need to update
      // any buttons that we may be linked to when the value changes
      // because buttons use their point's value as their own.
      if (this.isAttachmentPoint()) {
        this.listenTo(this, "change:value", function() {
          var buttons = this.getAttachmentButtons();

          for (var i = 0, len = buttons.length, button; i < len; i++) {
            button = buttons[i];
            button.trigger("change:value");
          }
        });
      }
    },

    isDisplayed: function() {
      if (this.isAttachmentPoint()) {
        return this.getDisplayed();
      } else {
        return this._super.apply(this, arguments);
      }
    },

    startProgressiveDisclosureListeners: function() {
      var attachPoint = this.getAttachmentPoint();

      if (this.isAttachmentButton() && attachPoint) {
        this.listenTo(attachPoint, 'change:value', function() {
          this.trigger('change:value');
        });
        this.listenTo(attachPoint, 'change:required', function() {
          this.trigger('change:required');
        });
        this.listenTo(attachPoint, 'change:samples', function() {
          this.trigger('change:samples');
        });
      }

      this._super();
    },

    setupValue: function(value) {
      var point = this.getAttachmentPoint(),
          Model = point ? point.model : null;

      return Model ? Model.models(value) : value;
    },

    equalsAnswer: function(entity) {
      throw new Error('We did not implement this yet!!!');
    },

    getSection: function() {
      if (this.isAttachmentPoint()) {
        return null;
      } else {
        return this._super.apply(this, arguments);
      }
    },

    getAttachmentPoint: function() {
      if (this.isAttachmentPoint()) {
        return this;
      }
      return this.getDependentsByType('attach')[0];
    },

    getAttachmentButtons: function() {
      if (this.isAttachmentButton()) {
        var point = this.getAttachmentPoint();

        if (point) {
          return point.getAttachmentButtons();
        }
        return [this];
      }
      return this.getDependenciesByType('attach');
    },

    getValue: function() {
      var attachPoint = this.getAttachmentPoint();

      if (this.isAttachmentPoint()) {
        return this._super.apply(this, arguments);
      }

      if (attachPoint) {

        return attachPoint.getValue.apply(attachPoint, arguments);
      }
    },

    setValue: function(value) {
      var attachPoint = this.getAttachmentPoint();

      if (this.isAttachmentPoint()) {
        return this._super.apply(this, arguments);
      }

      if (attachPoint) {

        return attachPoint.setValue.apply(attachPoint, arguments);
      }
    },

    getSamples: function() {
      var attachPoint = this.getAttachmentPoint();

      if (this.isAttachmentPoint()) {
        return this._super.apply(this, arguments);
      }

      if (attachPoint) {

        return attachPoint.getSamples.apply(attachPoint, arguments);
      }
    },

    setSamples: function(value) {
      var attachPoint = this.getAttachmentPoint();

      if (attachPoint === this) {
        return this._super.apply(this, arguments);
      }

      if (attachPoint) {

        return attachPoint.setSamples.apply(attachPoint, arguments);
      }
    }

  });


  var DummyFormEntityModel = BaseFormEntityModel.extend({

    isAnswered: function() {
      return true;
    },

    getValue: function() {
      return true;
    },

    deserializeAnswer: function(value) {

    },

    serializeAnswer: function(value) {

    }

  });


  var FormModels = {
    Form             : FormModel,
    Base             : BaseFormEntityModel,
    Boolean          : BooleanFormEntityModel,
    ExclusiveBoolean : ExclusiveBooleanFormEntityModel,
    Date             : DateFormEntityModel,
    Group            : GroupFormEntityModel,
    Record           : RecordFormEntityModel,
    Attachment       : AttachmentFormEntityModel,
    Dummy            : DummyFormEntityModel
  };

  FormModel.types = {
    base            : {
      model: BaseFormEntityModel,
      name: 'Section'
    },
    group : {
      model: GroupFormEntityModel,
      name: 'Group'
    },
    radio : {
      model: ExclusiveBooleanFormEntityModel,
      name: 'Radio'
    },
    label : {
      model: BaseFormEntityModel,
      name: 'Label'
    },
    textbox : {
      model: BaseFormEntityModel,
      name: 'TextBox'
    },
    checkbox : {
      model: BooleanFormEntityModel,
      name: 'Checkbox'
    },
    attachmentpoint : {
      model: AttachmentFormEntityModel,
      name: 'AttachmentPoint'
    },
    attachment : {
      model: AttachmentFormEntityModel,
      name: 'AttachmentButton'
    },
    textarea : {
      model: BaseFormEntityModel,
      name: 'TextArea'
    },
    datepicker : {
      model: DateFormEntityModel,
      name: 'DatePicker'
    }
  };


  var FormFactory = Vertebrae.Object.extend({

    properties: [
      'options'
    ],

    initialize: function() {
      this._super.apply(this, arguments);
      this.setOptions({});
      this.answerProcessors     = [];
      this.linkProcessors       = [];
      this.attachProcessors     = [];
      this.attachTypeProcessors = [];
    },

    types: function(types) {
      this.getOptions().types = types;
      return this;
    },

    progressiveDisclosure: function(value) {
      this.getOptions().progressiveDisclosure = value;
      return this;
    },

    answers: function(answers) {
      this.getOptions().answers = answers;
      return this;
    },

    template: function(template) {
      this.getOptions().template = template
      return this;
    },

    canLink: function(fn) {
      this.linkProcessors.push(fn);
      return this;
    },

    canAttach: function(fn) {
      this.attachProcessors.push(fn);
      return this;
    },

    canAttachType: function(fn) {
      this.attachTypeProcessors.push(fn);
      return this;
    },

    ruleProcessor: function(processorStack) {
      return function() {
        var that = this,
            args = arguments;

        if (!processorStack.length) {
          return true;
        }

        return _.all(processorStack, function(fn) {
          fn.apply(that, args);
        });
      }
    },

    setupAnswer: function(type, fn) {
      if (_.isFunction(type)) {
        fn = type;
        type = '';
      }
      this.answerProcessors.push({ type: String(type).toLowerCase(), fn: fn });
      return this;
    },

    answerProcessor: function(entity, originalValue) {

      return Promise.reduce(this.answerProcessors, function(value, processor) {

        if (!processor.type || processor.type == String(entity.getType()).toLowerCase()) {
          return processor.fn(entity, value);
        }
        return value;
      }, originalValue);
    },

    build: function() {
      var form    = null,
          options = this.getOptions();

      options.answerProcessor     = _.bind(this.answerProcessor, this);
      options.linkProcessor       = this.ruleProcessor(this.linkProcessors);
      options.attachProcessor     = this.ruleProcessor(this.attachProcessors);
      options.attachTypeProcessor = this.ruleProcessor(this.attachTypeProcessors);

      return Promise
          .bind(this)
          .then(function() {

            return Promise.props(options);
          })
          .tap(function(options) {
            if (options.template) {
              options.children = options.template.children || [];
              options.attachments = options.template.attachments || [];
            }
            //configure it....
            form    = new FormModels.Form(options);
            return form.start();
          })
          .then(function() {

            return form;
          });
    }

  },
  {
    start: function() {
      return new this();
    }
  });


  var FormView = Vertebrae.View.extend({

    templates: {
      'e3.form.init' : 'renderInit'
    },

    className: 'e3-form',

    entityElementTag: 'div',

    entityAttributes: {
      class: 'e3-form-entity'
    },

    propertyListeners: [
      'description',
      'displayed',
      'helpText',
      'label',
      'required',
      'text'
    ],

    entityTemplate: 'e3.form.entity.default',

    entityChildContainer: '.e3-form-entity-children-container',

    initialize: function() {
      this._rendering = false;
      this._super.apply(this, arguments);
      this.initializeProperties();

      // ...sooo....label ALWAYS needs to go at the front of the property listeners array
      // and displayed always needs to come last in the property listeners array
      this.propertyListeners = this.propertyListeners.slice().sort(function(a, b) {
        if (a == 'displayed' || b == 'label') {
          return 1;
        } else if (a == 'label' || b == 'displayed') {
          return -1;
        }
        return 0;
      });
    },

    getFormEntityViewByType: function(type) {
      var delegate = this.getDelegate(),
          View     = null;

      if (!_.isFunction(delegate.getFormEntityViewByType)) {
        throw new Error('Delegates of FormView must have "getFormEntityViewByType" defined.');
      }

      View = delegate.getFormEntityViewByType(type, this);

      if (!View) {
        // TODO
      }

      return View;
    },

    initializeProperties: function() {
      this.entityElementMap         = {};
      this.entityViewMap            = {};
      this.alignmentWidthsCache     = [];
      this.tabIndexCounter          = 1;
    },

    render: function() {
      this._rendering = true;
      var delegate = this.getDelegate();

      this.initializeProperties();
      this.stopListening();

      this.$el
          .html(this.renderInit())
          .addClass(this.className);

      if (!_.isFunction(delegate.getRootFormEntity)) {
        throw new Error('Delegates of FormView must have "getRootFormEntity" defined.');
      }
      var section = delegate.getRootFormEntity(this);

      var placeholder   = $(document.createElement('div'));
      var rootContainer = this.getRootEntityContainer();

      rootContainer.after(placeholder);
      rootContainer.detach();

      if (section) {
        this.renderFormEntity(section, rootContainer, null, []);
      }
      this._rendering = false;

      var alignments = this.alignmentWidthsCache || [];

      for (var i = 0, len = alignments.length, a; i < len; i++) {
        if (!_.isEmpty(alignments[i])) {
          a = _.last(alignments[i]);
          this.updateFormEntityAlignmentAtDepth(i, a.width);
        }
      }

      placeholder.replaceWith(rootContainer);
    },

    getNextTabIndex: function() {
      return this.tabIndexCounter++;
    },

    getRootEntityContainer: function() {
      return this.$('.e3-form-root-container');
    },

    isRendering: function() {
      return this._rendering;
    },

    setupEntityData: function(entity, index, list) {
      var displayedList = _.filter(list, function(e) { return e.getDisplayed(); });

      return {
        entity : entity,
        first  : entity === displayedList[0],
        last   : index == list.length -1
      };
    },

    setupEntityElement: function(el, entity) {

    },

    setupEntityToolbar: function(toolbar, entity, el) {

    },

    setupEntityView: function(entityView, entity) {
      // Persist the disabled state to newly rendered views.
      if (this._disabled) {
        this.disableFormEntity(entity, true);
      }
    },

    setupEntityListeners: function(entity, el) {
      var content = this.getEntityContentContainer(el);

      this.listenTo(entity, 'change:children', function() {
        var container = this.getEntityChildrenContainer(el),
            children  = container.children();

        children.detach();
        container.empty();

        this.renderFormEntities(entity.getChildren(), container);
      });

      this.listenTo(entity, 'destroy', function() {
        var view = this.getViewForEntity(entity);
        if (view) {
          view.destroy();
          delete this.entityViewMap[entity.getId()];
        }
        this.stopListening(entity);
      });

      this.listenToEntityPropertyChanges(entity, function(property) {
        this.entityPropertyDidChange(entity, property, content, el);
      });

    },

    showFormEntity: function(entity, el, force) {
      if (!entity.isSection()) {
        !this.isRendering() && !force ? el.slideDown() : el.show();
      }
    },

    hideFormEntity: function(entity, el, force) {
      if (!entity.isSection()) {
        !this.isRendering() && !force ? el.slideUp() : el.hide();
      }
    },

    updateFormEntityAlignmentAtDepth: function(depth, width) {
      var alignments = this.alignmentWidthsCache[depth];
      for (var i = 0, len = alignments.length, alignment; i < len; i++) {
        alignment = alignments[i];
        alignment.el.width(width);
      }
    },

    refreshFormEntityAlignmentWidth: function(entity, el) {
      var depth       = entity.getDepth(),
          cache       = this.alignmentWidthsCache,
          labelWidths = cache[depth] || (cache[depth] = []);
          greatest    = null,
          index       = -1,
          current     = null,
          insertIndex = 0;

      
      for (var i = 0, len = labelWidths.length, w; i < len; i++) {
        w = labelWidths[i];
        if (w.entityId == entity.getId()) {
          index = i;
          current = w;
          break;
        }
      }

      if (current) {
        labelWidths.splice(index, 1);
      } else {
        current = { entityId: entity.getId(), el: el  };
      }

      current.width = this.measureElementWidth(el.html(), el.css('font-size'));

      insertIndex = _.sortedIndex(labelWidths, current, 'width');

      labelWidths.splice(insertIndex, 0, current);

      greatest = _.last(labelWidths);

      if (!this.isRendering()) {
        this.updateFormEntityAlignmentAtDepth(depth, greatest.width);
      }

    },

    measureElementWidth: function(content, fontSize) {
      var span = this._measuringSpan;
      if (!span) {
        span = this._measuringSpan = document.createElement('span');
        span.style.position = 'absolute';
        span.style.visibility = 'hidden';
        span.style.height = 'auto';
        span.style.width = 'auto';
        document.body.appendChild(span);
      }
      span.innerHTML = content;
      span.style.fontSize = fontSize;

      return span.offsetWidth;
    },

    entityPropertyDidChange: function(entity, property, content, el) {
      switch (property) {
        case 'label':
          // label is in a different container than the other properties
          content = el.find('> .e3-form-entity-table-left');
        case 'text':
        case 'description':
        case 'helpText':
          var value = entity.getter(property) || '';
          var propertyEl = content.find('[data-property="' + property + '"]').html(value);
          if (value) {
            propertyEl.parent().removeClass('e3-form-property-empty');
          } else {
            propertyEl.parent().addClass('e3-form-property-empty');
          }
          break;
        case 'required':
          entity.isRequired() ? el.addClass('e3-form-entity-required') : el.removeClass('e3-form-entity-required');
          break;
        case 'displayed':
          this.refreshEntityListPosition(entity);
          entity.getDisplayed() ? this.showFormEntity(entity, el) : this.hideFormEntity(entity, el);
          break;
      }

      // if label changed then we need to recalculate the form alignment
      if (property == 'label') {
        var alignmentEl = content.find('.e3-form-entity-alignment');
        this.refreshFormEntityAlignmentWidth(entity, alignmentEl);
      }
    },

    resolveToId: function(entity) {
      if (entity && _.isFunction(entity.getId)) {
        entity = entity.getId();
      }
      return entity;
    },

    getViewForEntity: function(entity) {
      var id = this.resolveToId(entity)
      return this.entityViewMap[id];
    },

    setFormDisable: function(isDisabled) {
      this._disabled = isDisabled;
      var section = this.getDelegate().getRootFormEntity(this);

      if (section) {
        var entityView = this.getViewForEntity(section);

        this.setFormEntityDisable(isDisabled, section);
      }
    },

    disable: function() {
      this.setFormDisable(true);
    },

    enable: function() {
      this.setFormDisable(false);
    },

    setFormEntityDisable: function(isDisabled, entity, noRecurse) {
      var view = this.getViewForEntity(entity),
          el   = this.getEntityElement(entity);

      isDisabled ? el.addClass("e3-form-entity-disabled") : el.removeClass("e3-form-entity-disabled");

      // We have to make sure that the entity is displayed or else it may not have been rendered!!
      // See renderFormEntity to see how a form entity view may not have been rendered if
      // it is not displayed
      if (view && entity.isDisplayed()) {
        isDisabled ? view.disable(entity) : view.enable(entity);
      }

      if (!noRecurse) {
        entity.recurse(function(e) {
          this.setFormEntityDisable(isDisabled, e, true);
        }, this);
      }
    },

    disableFormEntity: function(entity, noRecurse) {
      this.setFormEntityDisable(true, entity, noRecurse);
    },

    enableFormEntity: function(entity, noRecurse) {
      this.setFormEntityDisable(false, entity, noRecurse);
    },

    listenToEntityPropertyChanges: function(entity, fn) {
      _.each(this.propertyListeners, function(property) {

        this.listenTo(entity, 'change:' + property, function() {
          fn.call(this, property);
        });

        entity.trigger('change:' + property);
      }, this);

    },

    renderFormEntities: function(list, container) {
      var len = list ? list.length : 0,
          i   = 0;

      for (i = 0; i < len; ++i) {
        this.renderFormEntity(list[i], container, i, list);
      }
    },

    createEntityElement: function(entity) {
      return $(document.createElement(this.entityElementTag))
          .attr(this.entityAttributes)
          .attr('data-id', entity.getId());
    },

    getEntityElement: function(entity) {
      var id = this.resolveToId(entity);

      if (!this.entityElementMap[id]) {
        this.entityElementMap[id] = this.createEntityElement(entity);
      }
      return this.entityElementMap[id];
    },

    refreshEntityListPosition: function(entity) {
      var list          = entity.getParent() ? entity.getParent().getChildren() : [entity],
          displayedList = _.filter(list, function(e) { return e.getDisplayed(); }),
          el            = this.getEntityElement(entity);

      if (el) {
        el
            .parent()
            .find('> .e3-form-entity')
            .removeClass('e3-form-entity-last')
            .removeClass('e3-form-entity-first');
      }

      if (_.isEmpty(displayedList)) {
        return;
      }

      var firstEl = this.getEntityElement(_.first(displayedList)),
          lastEl  = this.getEntityElement(_.last(displayedList));

      if (firstEl) {
        firstEl.addClass('e3-form-entity-first');
      }

      if (lastEl) {
        lastEl.addClass('e3-form-entity-last');
      }
    },

    renderFormEntity: function(entity, container, index, list) {
      var View                    = this.getFormEntityViewByType(entity.getType()),
          data                    = null,
          entityElement           = null,
          entityChildrenContainer = null,
          toolbarElement          = null,
          entityView              = null;

      data = this.setupEntityData(entity, index, list);
      data = _.extend({}, data, View.formEntityOptions(entity, index, list));

      entityElement = this
          .getEntityElement(entity)
          .html(this.template(this.entityTemplate, data));

      this.setupEntityToolbar(this.getEntityToolbarContainer(entityElement), entity, entityElement);

      entityChildrenContainer = this.getEntityChildrenContainer(entityElement);

      entityElement.addClass('e3-form-entity-depth-' + Number(entity.getDepth()));

      // add a class to the entity element with the type
      var viewClass = View.prototype.className ? View.prototype.className : 'e3-form-entity-base';
      entityElement.addClass(viewClass);

      if (!this.getViewForEntity(entity) && View) {

        entityView = View.setup(this.getEntityValueContainer(entityElement), this.getDelegate());

        if (entity.isDisplayed()) {
          this.renderFormEntityView(entity, entityView, entityElement);
        } else if (!entity.getDisplayed()) {
          this.hideFormEntity(entity, entityElement, true);

          var listenFn = function() {
            if (!entity.getDisplayed()) {
              this.listenToOnce(entity, 'change:displayed', listenFn);
              return;
            }
            this._rendering = true;

            this.renderFormEntityView(entity, entityView, entityElement, true);

            entity.recurse(function(e) {
              if (e.getDisplayed()) {
                this.renderFormEntityView(e, this.getViewForEntity(e), this.getEntityElement(e));
              }
            }, this);

            this._rendering = false;

            this.setupEntityListeners(entity, entityElement);
          };

          this.listenToOnce(entity, 'change:displayed', listenFn);
        }

        this.entityViewMap[entity.getId()] = entityView;
      }

      container.append(entityElement);
      this.entityElementMap[entity.getId()] = entityElement;

      this.setupEntityElement(entityElement, entity);
      
      if (entityView) {
        this.setupEntityView(entityView, entity);
      }

      this.renderFormEntities(entity.getChildren(), entityChildrenContainer);
    },

    renderFormEntityView: function(entity, view, el, noStart) {
      view.render(entity, this);
      view.setRendered(true);
      view.setupEntityListeners(entity);
      entity.trigger('change:value');
      if (noStart !== true) {
        this.setupEntityListeners(entity, el);
      }
    },

    getEntityContentContainer: function(el) {
      return el.find(' > .e3-form-entity-table-right > .e3-form-entity-contents');
    },

    getEntityValueContainer: function(el) {
      return this.getEntityContentContainer(el).find('.e3-form-entity-controls');
    },

    getEntityChildrenContainer: function(el) {
      return el.find(' > .e3-form-entity-table-right > .e3-form-entity-children-container');
    },

    getEntityToolbarContainer: function(el) {
      return el.find(' > .e3-form-entity-table-right > .e3-form-entity-toolbar');
    }

  });


  var BaseFormEntityView = Vertebrae.View.extend({

    className: 'e3-form-entity-base',

    render: function(entity, form) {
      this.entity = entity;
      this.formView = form;
      this.renderContent(entity);
    },

    getNextTabIndex: function() {
      return this.formView.getNextTabIndex();
    },

    renderContent: function(entity) {

    },

    setupEntityListeners: function(entity) {
      var oldValue = undefined;

      this.listenTo(entity, 'change:value', function() {
        this.valueDidChangeOnEntity(entity.getValue(), oldValue);
        oldValue = entity.getValue();
      });
    },

    valueDidChangeOnEntity: function(value, oldValue) {
      this.setElementValue(value, oldValue);
    },

    elementValueWillChange: function() {
      this.getDelegate().trigger("willchange:entity:value", { entity: this.entity });
    },

    elementValueDidChange: function() {
      this.getDelegate().trigger("change:entity:value", { entity: this.entity, value: this.getElementValue() });

    },

    disable: function() {
      this._disabled = true;
    },

    enable: function() {
      this._disabled = false;
    },

    getElementValue: function() {

    },

    setElementValue: function(value) {

    }

  }, {
    formEntityOptions: function(entity, index, list) {
      
    }
  });


  var ListFormEntityView = BaseFormEntityView.extend({

    className: 'e3-form-entity-list',

    addButtonText : 'Add',
    useAddButton  : true,

    listItemTemplate: '',

    templates: {
      'e3.form.entity.list' : 'renderListFormEntity'
    },

    events: {
      'click .e3-form-entity-list-add-button'   : 'handleAddButtonClick',
      'keydown .e3-form-entity-list-add-button' : 'handleAddButtonKeyup'
    },

    renderContent: function(entity) {
      var opts = {
        useAddButton  : this.useAddButton,
        addButtonText : this.addButtonText,
        tabIndex      : this.getNextTabIndex()
      };
      
      this.$el
          .html(this.renderListFormEntity(opts));
    },

    setElementValue: function(value) {
      var container = this.getListItemContainer();

      this.clearListItemContainer();

      if (_.isEmpty(value)) {
        this.renderEmptyList(container);
      } else {
        for (var i = 0, len = value.length, item; i < len; i++) {
          item = value[i];
          this.renderListItem(item, container);
        }

        this.updateAddButtonVisiblity();
      }
    },

    updateAddButtonVisiblity: function(value) {
      value = arguments.length ? value : this.entity.getValue();

      if (!this.entity.getHasMultiple()) {
          if (value && value.length >= 1) {
            // The entity this view represents doesn't support having multiple values
            // and we have one value set.  Disable the add button
            this.hideAddButton();
          } else {
            // We have no value set, show the button 
            this.showAddButton();
          }
        }
    },

    hideAddButton: function() {
      this.$('.e3-form-entity-list-add-button').css('display','none');
    },

    showAddButton: function() {
      // Using jquery's show function sets 'block' on things, which may
      // not be good for inline elements...
      this.$('.e3-form-entity-list-add-button').css('display','');
    },

    disable: function() {
      this._super.apply(this, arguments);
      this.hideAddButton();
    },

    enable: function() {
      this.showAddButton();
      this._super.apply(this, arguments);
    },

    clearListItemContainer: function() {
      this.getListItemContainer().empty();
    },

    getListItemContainer: function() {
      return this.$('.e3-form-entity-list-value');
    },

    handleAddButtonClick: function() {
      this.requestAddItem();
    },

    handleAddButtonKeyup: function(ev) {
      switch (ev.keyCode) {
        case 32:
        case 13:
          this.requestAddItem();
          ev.preventDefault();
          ev.stopPropagation();
          return false;
      };
    },

    requestAddItem: function() {
      this.getDelegate().trigger("entity:add:item", { entity: this.entity });
    },

    requestDeleteItem: function(item) {
      this.getDelegate().trigger("entity:remove:item", { entity: this.entity, item: item });
    },

    renderListItem: function(item, container) {
      if (this.listItemTemplate) {
        container.append(this.template(this.listItemTemplate, item));
      } else {
        container.append(item);
      }
    },

    renderEmptyList: function(container) {

    }


  });


  var AttachmentEntityView = ListFormEntityView.extend({

    className: 'e3-form-entity-attachment',

    addButtonText : 'Add Attachment',

    listItemTemplate: 'e3.form.entity.attachment.item',

    requestAddItem: function() {
      this.getDelegate().trigger("entity:add:attachments", { entity: this.entity });
    },

    renderEmptyList: function(container) {
      container.append('No Attachments');
    }


  });


  var CheckEntityView = BaseFormEntityView.extend({

    className: 'e3-form-entity-check',

    events: {
      'change input': 'elementValueDidChange'
    },

    renderContent: function(entity, form) {
      this.$el
          .html('<label><input type="checkbox" /><div data-property="text"></div></label>')
          .find('input')
          .attr({ tabindex: this.getNextTabIndex() })
          .addClass("e3-form-entity-checkbox-input")
          .next()
          .addClass("e3-form-entity-checkbox-text");
    },

    getElementValue: function() {
      return this.$('input').prop('checked');
    },

    setElementValue: function(value) {
      return this.$('input').prop('checked', !!value);
    },

    elementValueDidChange: function(ev) {
      if (this._disabled) {
        this.setElementValue(this.entity.getValue());
      } else {
        this._super();
      }
    }
    
  }, {
    formEntityOptions: function(entity, index, list) {
      return {
        noText        : true,
        noLabel       : true,
        noDescription : true
      }
    }
  });


  var DateEntityView = BaseFormEntityView.extend({

    className: 'e3-form-entity-date',

    events: {
      'click i'     : 'handleFocusInput',
      'focus input' : 'elementValueWillChange',
      'keyup input' : 'handleKeyup',
      'blur input'  : 'elementValueDidChange'
    },

    initialize: function() {
      this.handleKeyup = _.debounce(_.bind(this.handleKeyup, this), 1000);
      this._super.apply(this, arguments);
    },

    renderContent: function() {
      this.$el
          .html('<div><input/><i></i></div>')
          .find('input')
          .attr({ tabindex: this.getNextTabIndex() })
          .datepicker()
          .on('changeDate', _.bind(this.elementValueDidChange, this));
    },

    getElementValue: function() {
      return this.$('input').val();
    },

    setElementValue: function(value) {
      this.$('input').val(value);
    },

    handleKeyup: function() {
      this.elementValueDidChange();
    },

    handleFocusInput: function() {
      this.$('input').focus();
    },

    disable: function() {
      this._super.apply(this, arguments);
      this.$('input').prop('readonly', true);
    },

    enable: function() {
      this.$('input').prop('readonly', false);
      this._super.apply(this, arguments);
    }

  });


  var GroupEntityView = BaseFormEntityView.extend({

  });


  var LabelEntityView = BaseFormEntityView.extend({

    className: 'e3-form-entity-label',

  });


  var RadioEntityView = BaseFormEntityView.extend({

    className: 'e3-form-entity-radio',

    events: {
      'change input': 'elementValueDidChange'
    },

    renderContent: function(entity, view) {
      this.$el
          .html('<label><input type="radio" /><div data-property="text"></div></label>')
          .find('input')
          .attr({
            'name': 'radio-' + entity.getParent().getId(),
            tabindex: this.getNextTabIndex()
          })
          .addClass("e3-form-entity-radio-input")
          .next()
          .addClass("e3-form-entity-radio-text");
    },

    setElementValue: function(value) {
      this.$('input').prop('checked', !!value);
    },

    getElementValue: function() {
      // this will not be used...
    },

    elementValueDidChange: function(ev) {
      if (this._disabled) {
        // This is necessary because we need our siblings to 
        // emit change:value to update the adjacent radio controls
        this.entity.reloadValue();
      } else {
        this.getDelegate().trigger("change:entity:value", { entity: this.entity, value: true }); //verdad
      }
    }

  }, {
    formEntityOptions: function(entity, index, list) {
      return {
        noText        : true,
        noLabel       : true,
        noDescription : true
      }
    }
  });


  var TableEntityView = ListFormEntityView.extend({
    
    className: 'e3-form-entity-table',

    addButtonText : 'Add Item',
    theme         : 'rs',
    columns       : [
      { 
        name        : 'firstName',         
        displayName : 'First Name',                  
        width       : '46%' 
      },
      {
        name        : 'lastName',
        displayName : 'Last Name',
        width       : '46%'
      },
      {
        remove : true,
        width         : '8%'
      }
    ],

    renderContent: function() {
      this._super.apply(this, arguments);

      this.tableEl         = this.getListItemContainer();
      this.tableController = new E3Table.Controller(this.getTableOptions());
      this.tableController.setup(this.tableEl);
      this.tableController.start();
    },

    getData: function() {
      return this.entity.getValue();
    },

    removeTableItem: function(item) {
      this.requestDeleteItem(item);
    },

    getTableOptions: function() {
      return {
        columns  : this.columns,
        theme    : this.theme,
        delegate : this
      }
    },

    enable: function() {
      this._super.apply(this, arguments);
      this.updateRemoveColumnVisibility();
    },

    disable: function() {
      this._super.apply(this, arguments);
      this.updateRemoveColumnVisibility();
    },

    updateRemoveColumnVisibility: function() {
      // Update columns on table
      var columns = this.columns;
      if (this._disabled) {
        columns = _.filter(columns, function(c) {
          return !c.remove;
        });
      }
      this.tableController.setColumns(columns);
    },

    setElementValue: function(value) {
      this.tableController.refresh();

      // good to go!
      this.updateAddButtonVisiblity();
      this.updateRemoveColumnVisibility();
    },

  });

  var Redactor = $.Redactor;

  var TextAreaEntityView = BaseFormEntityView.extend({

    className: 'e3-form-entity-textarea',

    initialize: function() {
      this.handleKeyup = _.debounce(_.bind(this.handleKeyup, this), 1000);
      this._super.apply(this, arguments);
    },

    renderContent: function() {
      var textarea = this.$el
          .html('<textarea />')
          .find('textarea');

      var plugins = [];

      if (window.RedactorPlugins) {
        if (window.RedactorPlugins.imageEmbed) {
          plugins.push('imageEmbed');
        }
        if (window.RedactorPlugins.imageLoading) {
          plugins.push('imageLoading');
        }
      }

      var formDelegate    = this.formView.getDelegate(),
          redactorOptions = formDelegate && _.isFunction(formDelegate.getRedactorOptions) ? formDelegate.getRedactorOptions(this, plugins) : {};

      this.redactor = new Redactor(textarea.get(0), _.extend({
        linebreaks : true,
        minHeight  : 200,
        maxHeight  : 200,
        autoresize : false,
        plugins: plugins,
        tabindex: this.getNextTabIndex(),
        buttons: [
          'bold', 'italic', 'underline', 'deleted', '|', 'unorderedlist', 'orderedlist'
        ],
        blurCallback: _.bind(this.elementValueDidChange, this),
        focusCallback: _.bind(this.elementValueWillChange, this),
        changeCallback: _.bind(this.handleKeyup, this)
      }, redactorOptions));

    },

    getElementValue: function() {
      return this.redactor.get();
    },

    setElementValue: function(value) {
      this.redactor.set(value || '');
    },

    handleKeyup: function() {
      this.elementValueDidChange();
    },

    disable: function() {
      this._super.apply(this, arguments);
      // unbind all key events!
      this.redactor.$editor.off('.redactor');
      this.redactor.$source.off('.redactor-textarea')
      // hide the toolbar
      this.redactor.$toolbar.hide();
      // disable content editable
      this.redactor.$editor.attr('contenteditable', false);
    },

    enable: function() {
      // rebind all key events!
      this.redactor.buildBindKeyboard();
      // show the toolbar
      this.redactor.$toolbar.show();
      // enable content editable
      this.redactor.$editor.attr('contenteditable', true);
      this._super.apply(this, arguments);
    }
  });


  var TextBoxEntityView = BaseFormEntityView.extend({

    className: 'e3-form-entity-textbox',

    events: {
      'focus input' : 'elementValueWillChange',
      'keyup input' : 'handleKeyup',
      'blur input'  : 'elementValueDidChange'
    },

    initialize: function() {
      this.handleKeyup = _.debounce(_.bind(this.handleKeyup, this), 1000);
      this._super.apply(this, arguments);
    },

    renderContent: function() {
      this.$el
          .html('<input />')
          .find('input')
          .attr({ tabindex: this.getNextTabIndex() })
    },

    getElementValue: function() {
      return this.$('input').val();
    },

    setElementValue: function(value) {
      this.$('input').val(value);
    },

    handleKeyup: function() {
      this.elementValueDidChange();
    },

    disable: function() {
      this._super.apply(this, arguments);
      this.$('input').prop('readonly', true);
    },

    enable: function() {
      this.$('input').prop('readonly', false);
      this._super.apply(this, arguments);
    }

  });


  var EntityViews = {
    Base       : BaseFormEntityView,
    Attachment : AttachmentEntityView,
    Checkbox   : CheckEntityView,
    DatePicker : DateEntityView,
    Group      : GroupEntityView,
    Label      : LabelEntityView,
    Radio      : RadioEntityView,
    List       : ListFormEntityView,
    Table      : TableEntityView,
    TextArea   : TextAreaEntityView,
    TextBox    : TextBoxEntityView
  };


  var FormViews = {
    Form       : FormView,
    Entities   : EntityViews,
    types      : {}
  };

  _.each(EntityViews, function(View, name) {
    FormViews.types[name.toLowerCase()] = View;
  });


this["E3Templates"] = this["E3Templates"] || {};
this["E3Templates"]["e3-form"] = this["E3Templates"]["e3-form"] || {};

this["E3Templates"]["e3-form"]["e3.form.entity.attachment.item"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "<div class=\"form-entity-attachment-item\" title=\""
    + escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"text","hash":{},"data":data}) : helper)))
    + "\">\r\n  <div class=\"form-entity-attachment-text\">\r\n    <a target=\"_blank\" href=\""
    + escapeExpression(((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"url","hash":{},"data":data}) : helper)))
    + "\">\r\n      "
    + escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"text","hash":{},"data":data}) : helper)))
    + "\r\n    </a>\r\n  </div>\r\n  <div data-attachment-id=\""
    + escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"id","hash":{},"data":data}) : helper)))
    + "\" class=\"form-entity-attachment-item-remove\"></div>\r\n</div>";
},"useData":true});

this["E3Templates"]["e3-form"]["e3.form.entity.default"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  return "        <span data-property=\"label\"></span>\r\n";
  },"3":function(depth0,helpers,partials,data) {
  return "    <div class=\"e3-form-entity-property e3-form-entity-text\">\r\n        <span data-property=\"text\"></span>\r\n    </div>\r\n";
  },"5":function(depth0,helpers,partials,data) {
  return "    <div class=\"e3-form-entity-property e3-form-entity-description\">\r\n      <span data-property=\"description\"></span>\r\n    </div>\r\n";
  },"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, buffer = "<div class=\"e3-form-entity-table-left\">\r\n  <div class=\"e3-form-entity-alignment\">\r\n    <div class=\"e3-form-entity-property e3-form-entity-label\">\r\n";
  stack1 = helpers.unless.call(depth0, (depth0 != null ? depth0.noLabel : depth0), {"name":"unless","hash":{},"fn":this.program(1, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "    </div>\r\n  </div>\r\n</div>\r\n<div class=\"e3-form-entity-table-right\">\r\n\r\n  <div class=\"e3-form-entity-toolbar\"></div>\r\n  <div class=\"e3-form-entity-contents\">\r\n";
  stack1 = helpers.unless.call(depth0, (depth0 != null ? depth0.noText : depth0), {"name":"unless","hash":{},"fn":this.program(3, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  stack1 = helpers.unless.call(depth0, (depth0 != null ? depth0.noDescription : depth0), {"name":"unless","hash":{},"fn":this.program(5, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "\r\n    <div class=\"e3-form-entity-controls\"></div>\r\n  </div>\r\n  <div class=\"e3-form-entity-children-container\"></div>\r\n\r\n</div>\r\n\r\n\r\n";
},"useData":true});

this["E3Templates"]["e3-form"]["e3.form.entity.list"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "  <div class=\"e3-form-entity-list-add-button e3-form-button\" tabindex=\""
    + escapeExpression(((helper = (helper = helpers.tabIndex || (depth0 != null ? depth0.tabIndex : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"tabIndex","hash":{},"data":data}) : helper)))
    + "\">"
    + escapeExpression(((helper = (helper = helpers.addButtonText || (depth0 != null ? depth0.addButtonText : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"addButtonText","hash":{},"data":data}) : helper)))
    + "</div>\r\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, buffer = "<div class=\"e3-form-entity-list-container\">\r\n";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.useAddButton : depth0), {"name":"if","hash":{},"fn":this.program(1, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "</div>\r\n<div class=\"e3-form-entity-list-value\"></div>";
},"useData":true});

this["E3Templates"]["e3-form"]["e3.form.init"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  return "<div class=\"e3-form-root-container\">\r\n\r\n</div>";
  },"useData":true});


  return {
    Factory   : FormFactory,
    Views     : FormViews,
    Models    : FormModels,
    templates : this["E3Templates"]["e3-form"],
    version   : '0.0.21'
  };

}));

